export function toKebabCase(x: string) {
  return x
    .replace(/([0-9])([A-Z])/g, '$1-$2')
    .replace(/([a-z])([A-Z0-9])/g, '$1-$2')
    .toLowerCase();
}
